<template>
	<div>
	    <div class="utils__title mb-3">
	      <strong class="text-uppercase font-size-16">{{ $t('history.detail') }}</strong>
	    </div>
	    <div class="row">
	      <div class="col-lg-12">
	        <div class="card">
	          <div class="card-body">
	          	<a-form :layout="formLayout">
			      <a-form-item v-for="key in fields" :key="key" :label="$t('game.'+key)"
	          		:label-col="formItemLayout.labelCol"
	          		:wrapper-col="formItemLayout.wrapperCol">
			      	<span v-if="key=='created'">{{ details[key] | formatDate }}</span>
			      	<span v-else>{{ details[key] }}</span>
			      </a-form-item>
			      <a-form-item v-if="finalScores.length" :label="$t('game.winner')"
	          		:label-col="formItemLayout.labelCol"
	          		:wrapper-col="formItemLayout.wrapperCol">
			      	<p v-for="player in finalScores">{{ player.name }} : {{ player.score }}</p>
			      </a-form-item>
			      <a-form-item label=" "
	          		:label-col="formItemLayout.labelCol"
	          		:wrapper-col="formItemLayout.wrapperCol">
			      	<a-button v-if="finalScores.length==0 && !this.details.expired" type="default" @click="goGame">{{ $t('game.go') }}</a-button>
			      	<a-button v-if="finalScores.length" type="default" @click="exportData">{{ $t('game.export') }}</a-button>
			      </a-form-item>
			    </a-form>
	          </div>
	        </div>
	      </div>
	    </div>
	</div>
</template>
<script>
import api from '@/mixins/api'
import helper from '@/mixins/helper'
import config from '@/config'
export default {
	data() {
		return {
			loading: false,
			details: {},
			formLayout: 'horizontal',
			fields: ['title', 'room', 'mode', 'created']
		}
	},
	methods: {
		loadDetail() {
			this.api('game/detail?id='+this.$route.params.id).then(res => {
				this.details = res.details
			})
		},
		goGame() {
			window.open(`/play/${this.$route.params.id}`, '_blank')
		},
		exportData() {
			this.$router.push('/statistic/'+this.$route.params.id)
		}
	},
	mounted() {
		this.loadDetail()
	},
	computed: {
		formItemLayout() {
		  const { formLayout } = this;
		  return formLayout === 'horizontal'
		    ? {
		        labelCol: { span: 4 },
		        wrapperCol: { span: 14 },
		      }
		    : {};
		},
		finalScores() {
			return this.details.finalScores ? this.details.finalScores.splice(0,3) : []
		}
	},
	mixins: [api, helper]
}
</script>
<style>

</style>